import * as BECaller from '../../util/apiCaller';
import { setError, setSuccessMessage } from '../App/ErrorsActions';

export const FORECASTS = 'FORECASTING_LIST',
  FORECASTING = 'FORECASTING_FORECASTING',
  LOADING = 'FORECASTING_LOADING',
  OPEN_MODAL = 'FORECASTING_OPEN_MODAL',
  CREATE_FORECASTING = 'FORECASTING_SETTING_CREATE',
  DELETE_FORECASTING = 'FORECASTING_SETTING_DELETE';

export function handleError(error) {
  return setError(error);
}

export function successCreate() {
  return {
    type: CREATE_FORECASTING
  };
}

export function successDelete() {
  return {
    type: DELETE_FORECASTING
  };
}

export function openModal() {
  return {
    type: OPEN_MODAL
  };
}

export function getForecastings(dashboardId) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    BECaller.api(`forecasting/${dashboardId}`, 'get').then(
      data => {
        dispatch({
          type: FORECASTS,
          data: data
        });
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function getForecasting(dashboardId, id) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    BECaller.api(`forecasting/${dashboardId}/${id}`, 'get').then(
      data => {
        dispatch({
          type: FORECASTING,
          data: data
        });
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function createForecasting(id, dashboardId, data) {
  return dispatch => {
    if (!data.name) {
      return dispatch(handleError('Forecasting name is required'));
    }

    dispatch({
      type: LOADING,
      val: true
    });

    return BECaller.api(`forecasting/${dashboardId}/${id}`, 'post', data).then(
      data => {
        dispatch(successCreate());
        dispatch(setSuccessMessage('Forecast created successfully'));
        dispatch({
          type: FORECASTING,
          data: data
        });
      },
      err => {
        dispatch(handleError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}

export function deleteForecasting(id, dashboardId) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });
    return BECaller.api(`forecasting/${dashboardId}/${id}`, 'delete').then(
      () => {
        dispatch(successDelete());
        dispatch(setSuccessMessage('Forecasting deleted successfully'));
        dispatch({
          type: FORECASTING,
          data: {}
        });
      },
      err => {
        dispatch(handleError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}
